
<template>
    <div class="form-block">

        <div>
            <h2 class="form-block__title mb-3">{{title_form}}</h2>
            <div class="form-block_body">

                <div class="black_block d-flex flex-column">
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Name</div>
                        <input 
                            v-model="model_camera.name" 
                            type="text"
                            v-on:change="changeName"
                            class="form-control"
                            :class="{ error: !model_camera.name }"
                        >
                        <div @click="model_camera.name = ''" class="btn-close btn-close-input"></div>
                    </div>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Path</div>
                        <input 
                            v-model="model_camera.path" 
                            type="text" 
                            class="form-control"
                            :class="{ error: !model_camera.path }"
                        >
                        <div @click="model_camera.path = ''" class="btn-close btn-close-input"></div>
                    </div>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Description</div>
                        <input 
                            v-model="model_camera.description" 
                            type="text" 
                            class="form-control"
                            :class="{ error: !model_camera.description }"
                        >
                        <div @click="model_camera.description = ''" class="btn-close btn-close-input"></div>
                    </div>
                   
                </div>

            </div>

        </div>

        <div class="form-block__footer d-flex justify-content-between">

            <div class="form-block__footer_left d-flex justify-content-start align-items-end">

            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>
                <button @click="sendCamera" class="btn btn-primary" :disabled="validated == 0">Done</button>
            </div>

        </div>

    </div>
</template>

<script>
import {bus} from '../../bus';
import axios from "axios";
export default {
    props: ['prop_titleform','camera', 'crud'],
    data(){
        return{
            title_form: '',
            model_camera: {
                name: '',
                path: '',
                description: ''
            },
            validated: 0
        }
    },
    methods: {
        validate(){
            this.validated = this.model_camera.name && this.model_camera.path && this.model_camera.description;
        },
        changeName(){
            // this.validate();
            // console.log('change name');
            // console.log('this.model_camera from change name: ', this.model_camera);
        },        
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        sendCamera(){
            if(this.crud === 'create'){                
                this.addCamera();            }
            if(this.crud === 'update'){
                this.updateCamera(this.model_camera.id);
            }
        },
        addCamera(){
            
            axios.post( '/cameras',
                {
                    'name': this.model_camera.name,
                    'path': this.model_camera.path,
                    'description': this.model_camera.description
                },
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
            ).then((responce)=>{
                console.log('Send camera',responce);
                if (responce.data && responce.data.error) {
                    alert(responce.data.message || 'Failed to add camera');
                    return;
                }
                bus.$emit('openpopup', {
                    'open': false
                });                
                bus.$emit('getListCameras', true);

                this.model_camera.name = '';
                this.model_camera.path = '';
                this.model_camera.description  = '';

            }).catch(function(e){
                console.log(e);
                const msg = (e.response && e.response.data && e.response.data.message)
                    ? e.response.data.message
                    : 'Failed to add camera';
                alert(msg);
            });
        },
        updateVideo(video){
            axios.patch( '/videos',
                {
                    video
                },

                {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
            ).then((responce)=>{

            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        updateCamera(camera_id){
            axios.put( `/cameras/${camera_id}`,
                {                     
                    name: this.model_camera.name,
                    path: this.model_camera.path,
                    description: this.model_camera.description
                }
            ).then((responce)=>{
                console.log('update camera', responce);
                 bus.$emit('openpopup', {
                    'open': false
                });                
                bus.$emit('getListCameras', true);
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        convertTimestamp(timestamp) {
            let d = new Date(timestamp * 1000);
            let yyyy = d.getFullYear();
            let mm = ('0' + (d.getMonth() + 1)).slice(-2);
            let dd = ('0' + d.getDate()).slice(-2);
            let hh = d.getUTCHours();
            let min = ('0' + d.getMinutes()).slice(-2);
            let time = yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + min;
            return time;
        }

    },
    mounted(){        
        this.title_form = this.prop_titleform;
        if(this.camera){
            this.model_camera = {...this.camera};
            // console.log('this.model_camera from mounted 1 : ', this.model_camera);
            // console.log('this.model_camera.name from mounted 1 : ', this.model_camera.name);

        }        
         if(this.crud === 'create'){
                
                // console.log('this.model_camera from mounted 2 : ', this.model_camera);
                // console.log('this.model_camera.name from mounted 2 : ', this.model_camera.name);

                this.$set(this.model_camera, 'name', '');
                this.$set(this.model_camera, 'path', '');
                this.$set(this.model_camera, 'description', '');

                // console.log('this.model_camera from mounted 3 : ', this.model_camera);
                // console.log('this.model_camera.name from mounted 3 : ', this.model_camera.name);
        }
        if(this.crud === 'update'){
            this.validate();
        }
    },
    watch: {
        model_camera: {
            handler(val){
                // console.log('Change field');
                this.validate();
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
    .btn-close{
        margin-left: 1rem;
    }
    .error {
        border-color: red;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
